export default "__VITE_ASSET__C5OOCr2___"